<section class="bg-gray-50 py-24">

  <div class="w-11/12 mx-auto">

    <h2 class="text-4xl font-light mb-14">
      Why CIC, Why Now
    </h2>

    <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

     <div class="bg-primary-100 border border-primary-300 p-8 rounded-xl">
        <h3 class="text-lg font-semibold mb-3 text-primary-600">
          Rising Vendor Costs
        </h3>

        <p class="text-primary">
          Enterprises are facing increasing operational costs due to
          fragmented vendors managing different platforms.
        </p>
      </div>

 <div class="bg-primary-200 border border-primary-300 p-8 rounded-xl">
        <h3 class="text-lg font-semibold mb-3 text-primary-600">
          Fragmented Delivery
        </h3>

        <p class="text-primary">
          Multiple vendors and disconnected teams slow innovation
          and reduce operational efficiency.
        </p>
      </div>
 <div class="bg-primary-100 border border-primary-300 p-8 rounded-xl">
        <h3 class="text-lg font-semibold mb-3 text-primary-600">
          Slow Time-to-Market
        </h3>

        <p class="text-primary">
          Digital initiatives require faster execution and more
          agile engineering capabilities.
        </p>
      </div>

      <div class="bg-primary-200 border border-primary-300 p-8 rounded-xl">
        <h3 class="text-lg font-semibold mb-3 text-primary-600">
          Platform Ownership
        </h3>

        <p class="text-primary">
          Organizations need stronger ownership and governance
          across enterprise technology platforms.
        </p>
      </div>

    </div>

  </div>

</section>